import type {
  ImportBatchDto,
  ImportCommitResult,
  ImportKind,
  ImportPreviewResult,
} from "@grizzly/shared";
import { request } from "../http.js";

export const importsApi = {
  preview: (kind: ImportKind, fileName: string, csv: string) =>
    request<ImportPreviewResult>(`/imports/${kind}/preview`, {
      method: "POST",
      body: { fileName, csv },
    }),
  commit: (kind: ImportKind, fileName: string, csv: string) =>
    request<ImportCommitResult>(`/imports/${kind}/commit`, {
      method: "POST",
      body: { fileName, csv },
    }),
  listBatches: (kind?: ImportKind) =>
    request<{ items: ImportBatchDto[] }>(
      `/imports/batches${kind ? `?kind=${encodeURIComponent(kind)}` : ""}`
    ),
};
